// extracted by mini-css-extract-plugin
module.exports = {"root":"VehicleList_root__3M344","buttonMargin":"VehicleList_buttonMargin__TUwvT"};